import { setAssetBasePath } from '@resurs-internal/deposits-app-components';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

setAssetBasePath('/');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense
      fallback={
        <div
          aria-live="polite"
          role="status"
          style={{ padding: '1rem', textAlign: 'center' }}
        >
          Loading…
        </div>
      }
    >
      <App />
    </Suspense>
  </StrictMode>,
);
